export enum RewardsProgramImpementation {
Internal,
External,
}
